/**
 * Created by lu on 2017/9/11.
 */
var nb = require('./nb');
var $ = nb.opts.$;
var app = require('./app');
var Page = nb.define({
    parent: app.Page,
    view: {
        'class': 'nb-page',
        $html: [{
            'class': 'nb-page-header',
            $type: require('./view/header/Header'),
            // $slot: 'header',
            $model: 'header'
        }, {
            'class': 'nb-page-content',
            $slot: 'content'
        }, {
            'class': 'nb-page-footer',
            $type: require('./view/Footer'),
            // $slot: 'footer'
            $model:'footer'
        }]
    },
    method:{
        init:function () {
            var self = this;
            nb.model.onChange(nb.opts.clientReady,function(inEvent){
                self.getScreenWidth();
                $(window).resize(function () {
                    self.getScreenWidth();
                });//todo
            },this);
            nb.model.onChange(nb.opts.clientReady,function () {
                this._initLazyLoad();
                nb.model.onChange('refreshLazyLoad',function (inEvent) {
                    this._initLazyLoad();
                },this);
            },this);

        },
        getScreenWidth:function () {
            var screenWidth = $(document.body).width();
            var model = this.getModel();
            model.set('screenWidth',screenWidth);
        },
        _initLazyLoad:function () {
            $(function() {
                $(".lazyload").lazyload({
                    placeholder : "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVQImWP4////fwAJ+wP9CNHoHgAAAABJRU5ErkJggg==", //用图片提前占位
                    effect: "fadeIn",
                    threshold: 100
                });
            });
        }
    }
});
module.exports = Page;


//////////////////
// WEBPACK FOOTER
// ../src/js/page.js
// module id = 23
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32